<template>
  <div class="location">
    <table>
      <thead>
        <tr>
          <td>SPBU Name</td>
          <td>TRAFFIC</td>
        </tr>
      </thead>
      <tbody v-if="locations">
        <tr v-for="(item, index) in locations.location_set" :key="index">
          <td>{{item.location.title}}</td>
          <td>{{item.get_traffic | formatNumber}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'adx-dashboard-campaignreport-location',
  components: {

  },
  props: {

  },
  data() {
    return {
      locations: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.locations = this.$parent._data.dataMeasurement
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
